import { useTranslation } from "@opendash/i18n";
import { Select, SelectProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";

type Props = SelectProps;

export const PERIOD_TYPES = [
  "seconds",
  "minutes",
  "hours",
  "day",
  "day_of_the_month",
  "day_instance",
  "day_of_the_week",
  "day_of_the_year",
  "week",
  "week_of_the_year",
  "month",
  "year",
] as const;

export const PeriodSelect = observer((props: Props) => {
  const t = useTranslation();

  const options = useMemo(
    () =>
      PERIOD_TYPES.map((type) => ({
        label: t("opendash:cron.later.periodType." + type),
        value: type,
      })),
    []
  );

  return (
    <Select
      {...props}
      options={options}
      placeholder={t("opendash:cron.later.periodType.placeholder")}
    />
  );
});
